/*
 * 1-Minute Maths
 * Copyright © 2021 - 2022 White Rose Maths
 * CustomHeaderBackImage.tsx - Custom graphic for the back button.
 */
import { Image } from 'react-native';


const CustomHeaderBackImage = ({height}: {height: number}) => {
  return (
    <Image
      source={require('../assets/images/BackButton_72dpi.png')}
      style={{
        height: height,
        width: height,
        margin: height/5,
        resizeMode: 'contain'
      }}
    />
  );
};

export default CustomHeaderBackImage;
